module.exports = {
  "pageView": {
    "name": "pageview",
    "class": "view",
    "properties": {
      "screen": "string",
      "slug": {
        "type": "string",
        "isOptional": true
      },
      "locale": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "data-privacy-request-ui",
    "version": "1"
  },
  "interaction": {
    "name": "interaction",
    "class": "interaction",
    "properties": {
      "interaction": "string",
      "slug": {
        "type": "string",
        "isOptional": true
      },
      "locale": {
        "type": "string",
        "isOptional": true
      },
      "country": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "data-privacy-request-ui",
    "version": "1"
  }
};